export const MRZ_CR_REGEX = /^IDCRI[A-Z0-9<]{85}$/

function computeCheckDigit(str) {
  const weights = [7, 3, 1]
  let total = 0
  for (let i = 0; i < str.length; i++) {
    const c = str[i]
    const val = c === '<' ? 0 : c >= 'A' ? c.charCodeAt(0) - 55 : parseInt(c)
    total += val * weights[i % 3]
  }
  return String(total % 10)
}

export default function MRZCRReader(mrz) {
  const line1 = mrz.slice(0, 30)   
  const line3 = mrz.slice(60, 90)  

  // IDCRI = 5 chars, doc number at [5:14], check digit at [14]
  const docNumRaw = line1.slice(5, 14)
  const checkDigit = line1[14]
  const identification = docNumRaw.replace(/</g, '')

  if (computeCheckDigit(docNumRaw) !== checkDigit) {
    console.warn('[MRZCRReader] Check digit mismatch for document number:', identification)
  }

  const [surnames, givenNames = ''] = line3.split('<<')
  const [last_name = '', last_name_two = ''] = surnames.split('<')
  const first_name = givenNames.replace(/</g, ' ').trim()

  return { identification, first_name, last_name, last_name_two }
}
